import { render } from "./TrainingCertificate.vue?vue&type=template&id=1d6268ca&ts=true"
import script from "./TrainingCertificate.vue?vue&type=script&lang=ts"
export * from "./TrainingCertificate.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\sicip-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__